import MediaController from "../../config/media.js";

import "./menu.js";

import "./footer.js";

import "./custom/modals/coming-soon.js";

import "./custom/modals/join-the-wait.js";

import "./custom/modals/preorder-overlay.js";

import "./custom/modals/research.js";

import "./custom/modals/incentives.js";

const currentPage = document.body.dataset.page, pageScripts = {
    index: [ "./custom/index/index-section-2.js", "./custom/index/index-section-3.js", "./custom/index/index-section-4.js", "./custom/index/index-section-5.js", "./custom/index/index-section-6.js", "./custom/index/index-section-7.js", "./custom/index/index-section-8.js" ],
    autopilot: [ "./custom/autopilot/autopilot-section-1.js", "./custom/autopilot/autopilot-section-3.js", "./custom/autopilot/autopilot-section-4.js", "./custom/autopilot/autopilot-section-5.js", "./custom/autopilot/autopilot-section-6.js", "./custom/autopilot/autopilot-section-7.js", "./custom/autopilot/autopilot-section-8.js" ],
    developers: [ "./custom/developers/developers-section-1.js", "./custom/developers/developers-section-5.js" ],
    contact: [ "./custom/contact/contact-section-1.js" ],
    installers: [ "./custom/installers/installers-section-1.js" ],
    preorder: [ "./custom/preorder/preorder-section-1.js" ],
    pricing: [ "./custom/pricing/pricing-section-1.js", "./custom/pricing/pricing-section-2.js" ],
    incentives: [ "./custom/incentives/incentives-section-1.js" ],
    science: [ "./custom/science/science-section-1.js", "./custom/science/science-section-2.js" ],
    vibrantair: [ "./custom/vibrantair/vibrantair-section-1.js", "./custom/vibrantair/vibrantair-section-2.js", "./custom/vibrantair/vibrantair-section-3.js", "./custom/vibrantair/vibrantair-section-4.js", "./custom/vibrantair/vibrantair-section-5.js", "./custom/vibrantair/vibrantair-section-6.js", "./custom/vibrantair/vibrantair-section-7b.js", "./custom/vibrantair/vibrantair-section-8.js", "./custom/vibrantair/vibrantair-section-10.js" ]
};

pageScripts[currentPage] && pageScripts[currentPage].forEach((scriptPath => {
    import(scriptPath).then((() => {})).catch((err => {}));
}));